import React from "react";
import { Box } from "@mui/material";
import { isAnalogChannel, isDigitalChannel } from "../../../constants/channel/config";
import { customChannelSelectorStyles } from "./virtualScrollTableStyle";
import { RemoveIcon } from "./removeIcon";
import AnalogIcon from "../../../../assets/images/custom/analog_icon.svg";
import DigitalIcon from "../../../../assets/images/custom/digital_icon.svg";
import PropTypes from "prop-types";

export const DisplaySelectedChannel = (props) => {
  const { channels, chNo, selectedChannelsDigital, updateSelectedChannels } = props;
  const channel = channels.find((c) => c.chNo === chNo);
  const currVar = !isAnalogChannel(channel?.chType) ? selectedChannelsDigital.find(c => c.chNo === chNo)?.var : null;

  return (
    <Box key={chNo} sx={{...customChannelSelectorStyles.line, border: isAnalogChannel(channel?.chType) ? "1px solid #fa30f8b3" : "1px solid #84eb80b3" }}>
      {isAnalogChannel(channel?.chType)
        ? <Box component={"img"} src={AnalogIcon} sx={{ marginBottom: "-1px", marginRight: "8px" }} />
        : <Box src={DigitalIcon} sx={{ marginBottom: "-1px", marginRight: "8px" }} />
      }
      <Box sx={customChannelSelectorStyles.lineTitle}>{channel?.chName}</Box>
      {isDigitalChannel(channel?.chType)
        && <Box sx={customChannelSelectorStyles.lineTitleVar}>{"(" + currVar + ")"}</Box>
      }
      <Box sx={customChannelSelectorStyles.lineIcon} onClick={() => updateSelectedChannels(chNo, "", false)}>
        <RemoveIcon />
      </Box>
    </Box>
  );
};

DisplaySelectedChannel.propTypes = {
  channels: PropTypes.array,
  chNo: PropTypes.string,
  selectedChannelsDigital: PropTypes.bool,
  updateSelectedChannels: PropTypes.func,
}